function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5.8h5c1 0 1.7.8 1.7 1.7v.8h2.5c.9 0 1.6.8 1.6 1.7v1.7c0 .9-.7 1.6-1.6 1.6h-.1l-.8 9.2c0 1-.7 1.7-1.6 1.7H4.8c-.9 0-1.6-.8-1.6-1.6l-.8-9.3c-1 0-1.7-.7-1.7-1.6V5c0-1 .7-1.7 1.6-1.7h2.5v-.8c0-1 .8-1.7 1.7-1.7ZM2.3 5h13.4v1.7H2.3V5Zm1.8 3.3h9.8l-.7 9.1v.1H4.8l-.7-9.2Zm7.4-5.8v.8h-5v-.8h5Z",
  fill: "#006AFF"
});

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c96e8b8e.svg";
export { ForwardRef as ReactComponent };